import React, {useEffect} from 'react';
import {useStripe} from '@stripe/react-stripe-js';

const Checkout = ({ sessionId }) => {
    const stripe = useStripe();

    useEffect(() => {
        if (sessionId) {
            stripe.redirectToCheckout({ sessionId }).then((result) => {
                if (result.error) {
                    console.error(result.error.message);
                }
            });
        }
    }, [stripe, sessionId]);

    return (
        <div>
            <h2>Redirecting to payment...</h2>
        </div>
    );
};

export default Checkout;
